<script lang="ts">
  import type { IFooterGroup, ISocialMediaItem } from "types/backend/models/widgets/footer.entity";
  import { FooterType } from "./index";
  import ImageComponent from "$components/image.svelte";
  import { locale } from "$lib/services/i18n";

  export let footer: IFooterGroup[] = [];
  export let socialMedia: ISocialMediaItem[] = [];

  function showItems(view = 0) {
    const listOfClasses = ["nav-item"];
    const binary = (view >>> 0).toString(2).padStart(3, "0");
    +(binary.charAt(0) as string) === 1 && listOfClasses.push("mobile");
    +(binary.charAt(1) as string) === 1 && listOfClasses.push("tablet");
    +(binary.charAt(2) as string) === 1 && listOfClasses.push("desktop");
    return listOfClasses.join(" ");
  }

  function removeTicketString(str?: string) {
    return str ? str.replace(/tickets/gi, "").toLowerCase() : "";
  }

  function genUrl(locale: string, url?: string) {
    if (locale === "en") {
      return url || "/";
    }
    return `/${locale}${url}`;
  }
</script>

<footer class="footer">
  <section class="container">
    {#each footer as entry, i}
      {@const children = i === 0 ? entry.children : entry.children.slice(0, 8)}
      <div class={["nav", `sec-${footer.length}`].join(" ") + " " + showItems(entry.view)}>
        {#if entry.label.trim().toLowerCase() === "logo"}
          <h5>
            <img src="/logo.svg" alt="Football Ticket Pad" />
          </h5>
        {:else if entry.label}
          <h5>{entry.label}</h5>
        {/if}
        <ul>
          {#each children || [] as { type, view, label, url, icon }}
            <li
              class={[i == 0 ? "info-col" : "link-col", showItems(view)].join(" ")}
              title={label}
              class:icon={type === FooterType.Icon}
            >
              {#if type === FooterType.Text}
                <span>{label}</span>
              {:else if type === FooterType.Icon && icon?.path}
                <a href={url}><ImageComponent image={icon} /></a>
              {:else if type === FooterType.Separator}
                <div class={["nav-item separator", showItems(view)].join(" ")}></div>
              {:else}
                <a
                  title={removeTicketString(label)}
                  href={genUrl($locale, url)}
                  target={type === "custom" ? "_blank" : "_self"}
                >
                  {removeTicketString(label)}
                </a>
              {/if}
            </li>
          {/each}
          {#if i === 0}
            <li class="info-col desktop">
              <div class="social-media">
                {#each socialMedia as item}
                  <a href={item.url}><ImageComponent image={item.logo} /></a>
                {/each}
              </div>
            </li>
          {/if}
        </ul>
      </div>
    {/each}
  </section>
  <div class="mobile-social-media container">
    <div class="connect">Connect</div>
    <div class="social-media">
      {#each socialMedia as item}
        <a href={item.url}><ImageComponent image={item.logo} /></a>
      {/each}
    </div>
  </div>
  <div class="bottom">2014-2025 Footballticketpad. All rights reserved.</div>
</footer>

<style lang="scss">
  @use "index.scss";
</style>
